import createRoute from '@widesk-ui/tools/createRoute';
import CodeModel   from '@models/code/CodeModel';

export default createRoute.splitView('/codes', 'shop', 'CodeSplitView', CodeModel.localize('plural'));
